import { createContext, useEffect, useState } from "react";
import { BreakpointOptions } from "../../types/theming";
import { ViewportSsrContextProps } from "./useViewport.types";

const ViewportSsrContext = createContext<BreakpointOptions | null>(null);

const ViewportSsrProvider: React.FC<ViewportSsrContextProps> = ({
	breakpoint,
	...props
}) => {
	const [currentBreakpoint, setCurrentBreakpoint] =
		useState<BreakpointOptions | null>(breakpoint);

	useEffect(() => {
		// The whole point of the context|provider is to capture the 'current' window breakpoint
		// for responsive rendering on the server. After the initial server-side rendering, we're
		// no longer interested in this value. A useEffect is used to nullify it.
		setCurrentBreakpoint(null);
	}, []);

	return (
		<ViewportSsrContext.Provider value={currentBreakpoint}>
			{props.children}
		</ViewportSsrContext.Provider>
	);
};

export { ViewportSsrContext, ViewportSsrProvider };
